import { RefObject, useEffect } from "react";

export const useOnClickOutside = (
  ref: RefObject<Element | null>,
  handler: (e: MouseEvent | TouchEvent) => void,
  additionalRefs: RefObject<Element | null>[] = [],
) => {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      const target = event.target;
      if (
        !ref.current ||
        !(target instanceof Node) ||
        [ref, ...additionalRefs].some(
          (currentRef) =>
            currentRef.current && currentRef.current.contains(target),
        )
      ) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [additionalRefs, ref, handler]);
};
